"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CategoryIcon_1 = __importDefault(require("./CategoryIcon"));
var CategoryTextRaw = function (_a) {
    var id = _a.id, path = _a.path, color = _a.color;
    return (react_1.default.createElement("div", { style: { display: "flex", gap: "0.4em", alignItems: "center" } },
        react_1.default.createElement(CategoryIcon_1.default, { path: path, fill: "#".concat(color), size: 24 }),
        react_1.default.createElement("span", { style: { flex: 1 } }, id)));
};
exports.default = CategoryTextRaw;
